import { render, staticRenderFns } from "./ModuleLayout.vue?vue&type=template&id=1e47e9c8&scoped=true&"
import script from "./ModuleLayout.vue?vue&type=script&lang=ts&"
export * from "./ModuleLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleLayout.vue?vue&type=style&index=0&id=1e47e9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e47e9c8",
  null
  
)

export default component.exports